import { Injectable } from '@angular/core';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {

  constructor(
    private _http: HttpClient
  ) { }

  public getReviews(page,pp,filters): Observable<iHttpPaginatedResponse>{
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/reviews?page=${page}&pp=${pp}&${filters}`).pipe(
      map(res => {
        return res;
      })
    );
  }

  public getReview(id:number):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/review/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public approveReview(id:number):Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/review/'+id, {status:'moderated'}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public rejectReview(id:number):Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/review/'+id, {status:'rejected'}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public approveAllPending(filters):Observable<any>{
    return this._http.put(environment.apiEndpoint+`/api/admin/updatePendingReviews/${filters}`, {status:'moderated'}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public rejectAllPending(filters):Observable<any>{
    return this._http.put(environment.apiEndpoint+`/api/admin/updatePendingReviews/${filters}`, {status:'rejected'}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
